import { ClearCacheButton } from '../clear_cache'
import { defineMessages, injectIntl } from 'react-intl'
import { Vinyl } from 'spa/components/vinyl'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import styles from './styles'

const localizedMessages = defineMessages({
  loading: {
    id: 'djcity.common.images.loading.alt',
    defaultMessage: 'Loading',
  },
  loadingText: {
    id: 'djcity.common.loading',
    defaultMessage: 'Loading...',
  },
})

export const Loading = injectIntl(
  ({ loading = true, absolute, className, intl, withHelp, customText }) => {
    const [showHelp, setShowHelp] = useState(false)

    useEffect(() => {
      if (loading) {
        const toRef = setTimeout(() => {
          setShowHelp(true)
        }, 10000)
        return () => clearTimeout(toRef)
      }
    }, [loading])

    return loading ? (
      <div
        className={classNames(
          styles.loadingContainer,
          {
            [styles.absolute]: !!absolute,
          },
          className
        )}
      >
        <div className={styles.loading}>
          <Vinyl animated className={styles.vinyl} />
          <span className={styles.loadingText}>
            {customText ||intl.formatMessage(localizedMessages.loadingText)}
          </span>
        </div>
        {withHelp && showHelp && <ClearCacheButton isLoadingPage={true} />}
      </div>
    ) : null
  }
)

Loading.propTypes = {
  absolute: PropTypes.bool,
  className: PropTypes.string,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  loading: PropTypes.bool,
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
}
